'use client';

import React, { forwardRef } from 'react';
import { cn } from '@/components/ui/_lib/cn';
import type { UiSkeletonProps } from '@/components/ui/_lib/skeletonProps';
import { useDeferredSkeleton } from '@/components/ui/_lib/useDeferredSkeleton';
import { SkeletonLines } from '@/components/ui/_lib/SkeletonLines';
import { SKELETON_BY_COMPONENT } from '@/components/ui/_lib/skeletonRegistry';

export type NavProps = React.HTMLAttributes<HTMLElement> & { 'aria-label'?: string; sidebarOpen?: boolean; mobile?: boolean } & UiSkeletonProps;

const sk = SKELETON_BY_COMPONENT.Nav;

const Nav = forwardRef<HTMLElement, NavProps>((props, ref) => {
  const {
    skeleton = false,
    skeletonMaxWaitMs = 2000,
    skeletonLines,
    mobile: _mobile,
    sidebarOpen: _sidebarOpen,
    className,
    children,
    ...domProps
  } = props;

  const showSkeleton = useDeferredSkeleton(skeleton, skeletonMaxWaitMs);

  return (
    <nav
      ref={ref}
      className={cn('group', 'nav', className)}
      {...domProps}
    >
      <SkeletonLines show={showSkeleton} shape={sk.shape} lines={skeletonLines ?? sk.lines}>
        {children}
      </SkeletonLines>
    </nav>
  );
});

Nav.displayName = 'Nav';

export default Nav;
